import * as tagUtil from './LogTagData';

const generateOTP = () => {
    let data = {
        page_event : 'view',
        page_name : 'myvodacom: business: two factor authentication: OTP',
        page_channel : 'accounts',
        page_master_tab : 'business',
        page_category : 'two factor authentication',
        page_type: 'content',
        service_application_event : 'start',
        service_application_name : 'business: solutions:  two factor authentication: OTP',
        service_application_step : 'business: solutions: two factor authentication: OTP'

    };

    try {
        window.tagUtil.view(data);
    } catch (e) {
        tagUtil.logError(e);
    }
};

const pageLoadOTP = () => {
    let data = {
        page_event: 'view',
        page_name: 'vodacom: business: self service: two factor authentication: otp',
        page_channel: 'accounts',
        page_master_tab: 'business',
        page_category: 'two factor authentication',
        page_type: 'content',                                                                                    
        service_application_name: 'vodacom: business: self service: two factor authentication: otp',
        service_application_step: 'vodacom: business: self service: two factor authentication: otp'
    };

    try {
        window.tagUtil.view(data);
    } catch (e) {
        tagUtil.logError(e);
    }
};

const submitOTP = () => {
    let data = {
        link_type: 'o',
        link_name: 'vodacom: business: self service: two factor authentication: otp: submit otp'
    };

    try {
        window.tagUtil.link(data);
    } catch (e) {
        tagUtil.logError(e);
    }
};

const blockedOTPButtonClick = () => {
    let data = {
        link_type: 'o',
        link_name: 'vodacom: business: self service: two factor authentication: otp: submit otp: okay'
    };

    try {
        window.tagUtil.link(data);
    } catch (e) {
        tagUtil.logError(e);
    }
};

const generateOTPError = (message) => {
    let data = {
        page_form_event : 'error',
        page_errors : message,
        page_name : 'myvodacom: business:two factor authentication: generate OTP error',
        service_application_event : 'finish',
        service_application_name : 'business: solutions: two factor authentication: OTP',
        service_application_step : 'business: solutions:  two factor authentication: OTP: OTP failed'
    };

    try {
        window.tagUtil.view(data);
    } catch (e) {
        tagUtil.logError(e);
    }
};

const errorOkayButtonEvent = () => {
    let data = {
        link_type : 'o',
        link_name : 'myvodacom: business: two factor authentication: OTP: okay'
    };

    try {
        window.tagUtil.link(data);
    } catch (e) {
        tagUtil.logError(e);
    }
};

const wrongOTP = (message) => {
    let data = {
        page_form_event : 'error',
        page_errors : message,
        page_name : 'myvodacom: business:two factor authentication: wrong OTP error',
        service_application_event : 'finish',
        service_application_name : 'business: solutions: two factor authentication: OTP',
        service_application_step : 'business: solutions:  two factor authentication: OTP: OTP failed'
    };

    try {
        window.tagUtil.view(data);
    } catch (e) {
        tagUtil.logError(e);
    }
};

const oneAttemptLeft = (message) => {
    let data = {
        page_form_event : 'error',
        page_errors : message,
        page_name : 'myvodacom: business:two factor authentication: OTP last attempt error',
        service_application_event : 'finish',
        service_application_name : 'business: solutions: two factor authentication: OTP',
        service_application_step : 'business: solutions:  two factor authentication: OTP: OTP failed'
    };

    try {
        window.tagUtil.view(data);
    } catch (e) {
        tagUtil.logError(e);
    }
};

const lockedOTP = (message) => {
    let data = {
        page_form_event : 'error',
        page_errors : message,
        page_name : 'myvodacom: business:two factor authentication: locked OTP error',
        service_application_event : 'finish',
        service_application_name : 'business: solutions: two factor authentication: OTP',
        service_application_step : 'business: solutions:  two factor authentication: OTP: OTP failed'
    };

    try {
        window.tagUtil.view(data);
    } catch (e) {
        tagUtil.logError(e);
    }
};

const OTPResent = () => {
    let data = {
        page_event : 'view',
        page_name : 'myvodacom: business: two factor authentication: resent OTP',
        page_channel : 'accounts',
        page_master_tab : 'business',
        page_category : 'two factor authentication',
        page_type : 'content'
    };

    try {
        window.tagUtil.view(data);
    } catch (e) {
        tagUtil.logError(e);
    }
};

const FailedOTPResent = (message) => {
    let data = {
        page_form_event : 'error',
        page_errors : message,
        page_name : 'myvodacom: business:two factor authentication: resend OTP error'
    };

    try {
        window.tagUtil.view(data);
    } catch (e) {
        tagUtil.logError(e);
    }
};


const resendOTP = () => {
    let data = {
        link_type: 'o',
        link_name: 'vodacom: business: self service: two factor authentication: otp: resend otp'
    };

    try {
        window.tagUtil.link(data);
    } catch (e) {
        tagUtil.logError(e);
    }
};

const invalidOtpEntered = (message) => {
    let data = {
        page_form_event : 'error',
        page_errors : message,
        page_name : 'vodacom: business: self service: two factor authentication: invalid otp 1 error',
    };

    try {
        window.tagUtil.view(data);
    } catch (e) {
        tagUtil.logError(e);
    }
};

const secondInvalidOtpEntered = (message) => {
    let data = {
        page_form_event : 'error',
        page_errors : message,
        page_name : 'vodacom: business: self service: two factor authentication: invalid otp 2 error',
    };

    try {
        window.tagUtil.view(data);
    } catch (e) {
        tagUtil.logError(e);
    }
};

const lastInvalidOtpEntered = (message) => {
    let data = {
        page_form_event : 'error',
        page_errors : message,
        page_name : 'vodacom: business: self service: two factor authentication: invalid otp 3 error',
        service_application_event: 'finish',
        service_application_name: 'vodacom: business: self service: two factor authentication: invalid otp 3 error',
        service_application_step: 'vodacom: business: self service: two factor authentication: entered 3 invalid otp'
    };

    try {
        window.tagUtil.view(data);
    } catch (e) {
        tagUtil.logError(e);
    }
};

const OTPsuccefullyResent = () => {
    let data = {
        page_event: 'view',
        page_name: 'vodacom: business: self service: two factor authentication: otp: resent otp',
        page_channel: 'accounts',
        page_master_tab: 'business',
        page_category: 'two factor authentication',
        page_type: 'content'
    };

    try {
        window.tagUtil.view(data);
    } catch (e) {
        tagUtil.logError(e);
    }
};


export {
    generateOTP,
    submitOTP,
    generateOTPError,
    errorOkayButtonEvent,
    wrongOTP,
    oneAttemptLeft,
    lockedOTP,
    OTPResent,
    FailedOTPResent,
    resendOTP,
    invalidOtpEntered,
    secondInvalidOtpEntered,
    lastInvalidOtpEntered,
    OTPsuccefullyResent,
    pageLoadOTP,
    blockedOTPButtonClick
};
